import request from '@/utils/request'
import URL from '@/api/urlTranslator'

export function getTemplateTypeList(params) {
  return request({
    url: URL.sys.templateType,
    method: 'get',
    params
  })
}

export function queryTemplateTypeSchemaType(templateType) {
  return request({
    url: URL.sys.queryTemplateTypeSchemaType,
    method: 'get',
    params: { templateType }
  })
}

export function save(data) {
  return request({
    url: URL.sys.templateType,
    method: 'post',
    data
  })
}

export function batchRemove(uuids) {
  return request({
    url: URL.sys.templateType,
    method: 'DELETE',
    data: uuids
  })
}
